import {
  characterWalk
} from './characterWalk'

const createWalkAnimation = (target) => {
  return (tl, options) => {
    options.duration = options.duration || 3500
    options.left = options.left || ['-20%', '36%']
    if(!options.right) {
      tl
      .add({
        targets: target,
        left: options.left,
        translateY: characterWalk(options.duration),
        easing: 'linear',
        duration: options.duration,
        begin: options.begin,
        complete: options.complete
      })
    } else {
      tl
      .add({
        targets: target,
        right: options.right,
        translateY: characterWalk(options.duration),
        easing: 'linear',
        duration: options.duration,
        begin: options.begin,
        complete: options.complete
      })
    }
  }
}

export {createWalkAnimation}



// WEBPACK FOOTER //
// ./src/assets/js/utils/createWalkAnimation.js